import React, { Component } from 'react'
import VehiculeInfoComponent from './VehiculeInfoComponent'
import ClientInfoComponent from './ClientInfoComponent'
import OffresComponent from './OffresComponent'
import FinalQuoteComponent from './FinalQuoteComponent'


class QuoteComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            progress : 25,
            dateMEC : "",
            usage: "A1",
            lob : "AUTO",
            energie : "",
            puissanceFiscale : "",
            valeurNeuf : "" ,
            valeurVenale : "",
            valeurGlaces : "",
            datePermis : "",
            dateNaissance : "",
            nombreSinistres : "",
            offres : []
        }
        this.stepUp = this.stepUp.bind(this);
        this.stepDown = this.stepDown.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOptionUsageChange = this.handleOptionUsageChange.bind(this);
       
    }

    componentDidMount() {
        
    }



    handleOptionUsageChange = changeEvent => {
      this.setState({
        usage: changeEvent.target.value
      });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    handleDateMECChange = date => {
          this.setState({
            dateMEC: date
          });
        };

    handleDatePermisChange = date => {
          this.setState({
            datePermis: date
          });
        };

    handleDateNaisChange = date => {
          this.setState({
            dateNaissance: date
          });
        };

    stepUp() {
      let stepTemp = this.state.step;
      let progressTemp = this.state.progress;
        //console.log("avant" + stepTemp);
        stepTemp = stepTemp + 1;
        progressTemp  = progressTemp + 25;
        this.setState({step : stepTemp, progress : progressTemp});
    }

    stepDown() {
      let stepTemp = this.state.step;
      let progressTemp = this.state.progress;
        //console.log("avant" + stepTemp);
        stepTemp = stepTemp - 1;
        progressTemp  = progressTemp - 25;
        this.setState({step : stepTemp, progress : progressTemp});
    }

    render() {

        return (
            <React.Fragment>
            <div class="text-center mt-4">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-3 col-3 col-sm-3 col-md-3"> 
                {this.state.step === 1 ? <i class="d-block fa mb-2 text-success fa-car fa-3x"></i>
                 :                       <i class="d-block fa mb-2 text-muted fa-car fa-2x"></i>}
                  <h6> <b>Votre véhicule</b></h6>
                </div>
                <div class="col-lg-3 col-3 col-sm-3 col-md-3">
                {this.state.step === 2 ? <i class="d-block fa mb-2 text-success fa-user-circle fa-3x"></i>
                 :                       <i class="d-block fa mb-2 text-muted fa-user fa-2x"></i>}
                  <h6> <b>Un peu sur vous</b></h6>
                </div>
                <div class="col-lg-3 col-3 col-sm-3 col-md-3 "> 
                {this.state.step === 3 ? <i class="d-block fa mb-2 text-success fa-files-o fa-3x"></i>
                 :                       <i class="d-block fa mb-2 text-muted fa-file-o fa-2x"></i>}
                  <h6> <b>Garanties</b></h6>
                </div>
                <div class="col-lg-3 col-3 col-sm-3 col-md-3"> 
                {this.state.step === 4 ? <i class="d-block fa mb-2 text-success fa-check-circle fa-3x"></i>
                 :                       <i class="d-block fa mb-2 text-muted fa-check fa-2x"></i>}
                  <h6> <b>Résultat</b></h6>
                </div>
              </div>
            </div>
          </div>
          <div class="py-2">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="progress">
                  <div class="progress-bar progress-bar-striped bg-info" role="progressbar" 
                      style={{width: `${this.state.progress}%`}}>{this.state.progress}%
                  </div>
                  </div>
                </div>
              </div>
              {(this.state.step === 1) && <VehiculeInfoComponent {...this.props} {...this.state}
                                              handleChange={this.handleChange}
                                              handleDateMECChange={this.handleDateMECChange}
                                              handleOptionUsageChange={this.handleOptionUsageChange}/>}
              {(this.state.step === 2) && <ClientInfoComponent {...this.props} {...this.state}
                                              handleChange={this.handleChange}
                                              handleDateNaisChange={this.handleDateNaisChange}
                                              handleDatePermisChange={this.handleDatePermisChange}/>}
              {(this.state.step === 3) && <OffresComponent {...this.props} {...this.state}/>}
              {(this.state.step === 4) && <FinalQuoteComponent {...this.props}/>}
            
              <div class="row mt-2">
                <div class="col-md-6 col-sm-2">
                {(this.state.step  > 1) &&
                <div class="text-left">
                    <button type="submit" class="btn btn-info" onClick={() => this.stepDown()}>Précedent</button>
                </div>
                }
                </div>
                <div class="col-md-6 col-sm-2">
                {(this.state.step < 4) &&
                    <div class="text-right">
                    <button type="submit" class="btn btn-info" onClick={() => this.stepUp()}>Suivant</button>
                    </div>
                }
                </div>
                </div>
            </div>
          </div>
          </React.Fragment>

        );
    }

}
export default QuoteComponent;